export interface SectionStep {
  path: string;
  history: string[];
}

export const previousSectionPath = (
  history: string[],
  currentPath?: string
): SectionStep | undefined => {
  const trail = [...history];
  while (trail.length > 0 && trail[trail.length - 1] === currentPath) {
    trail.pop();
  }
  const path = trail.pop();
  return path ? { path, history: trail } : undefined;
};

const normalize = (value: unknown): string =>
  value === undefined || value === null || value === ''
    ? ''
    : JSON.stringify(value);

export const hasUnsavedAnswers = (
  elements: { dataSource?: string; key?: PropertyKey }[],
  formValues: Record<string, unknown>,
  savedValues: Record<string, unknown> | undefined
): boolean =>
  elements.some(element => {
    const field = element.dataSource || element.key;
    if (field === undefined || field === '') return false;
    const name = String(field);
    return normalize(formValues[name]) !== normalize(savedValues?.[name]);
  });

export const SECTION_HISTORY_LIMIT = 50;

export const appendSectionHistory = (
  history: string[],
  path: string | undefined
): string[] => {
  const next = path ? [...history, path] : [...history];
  return next.slice(-SECTION_HISTORY_LIMIT);
};

export const parseSectionHistory = (raw?: string): string[] => {
  if (!raw) return [];
  try {
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed) &&
      parsed.every(entry => typeof entry === 'string')
      ? parsed
      : [];
  } catch {
    return [];
  }
};
